import type {FormEnvironment, NetworkResponse} from "./Types";

function extractJson(response: NetworkResponse):Promise<any> {
    if (response.ok) {
        if (response.json !== undefined) return response.json();
        return Promise.resolve("");
    }
    return Promise.reject(response);
}

export function getJson(env: FormEnvironment, endpoint: string): Promise<any> {
    return env.net.fetch(endpoint, "GET").then(extractJson);
}

export function postJson(env: FormEnvironment, endpoint: string, body: any): Promise<any> {
    return env.net.fetch(endpoint, "POST", body).then(extractJson);
}

export function putJson(env: FormEnvironment, endpoint: string, body: any): Promise<any> {
    return env.net.fetch(endpoint, "PUT", body).then(extractJson);
}

export function patchJson(env: FormEnvironment, endpoint: string, body: any): Promise<any> {
    return env.net.fetch(endpoint, "PATCH", body).then(extractJson);
}
